// PopoverTypes shared between projects
export var PopoverType = /*#__PURE__*/ function(PopoverType) {
    PopoverType["ADD_TO_COLLECTION_PRIMARY"] = "ADD_TO_COLLECTION_PRIMARY";
    PopoverType["ADD_TO_COLLECTION_SECONDARY"] = "ADD_TO_COLLECTION_SECONDARY";
    PopoverType["ADD_TO_PRIVATE_COLLECTION_PRIMARY"] = "ADD_TO_PRIVATE_COLLECTION_PRIMARY";
    PopoverType["ADD_TO_PRIVATE_COLLECTION_SECONDARY"] = "ADD_TO_PRIVATE_COLLECTION_SECONDARY";
    PopoverType["ADD_TO_GROUP_PRIMARY"] = "ADD_TO_GROUP_PRIMARY";
    PopoverType["ADD_TO_GROUP_SECONDARY"] = "ADD_TO_GROUP_SECONDARY";
    PopoverType["GALLECTION_FOLDER"] = "GALLECTION_FOLDER";
    return PopoverType;
}({});

//# sourceMappingURL=types.js.map